import React, { useEffect, useState } from 'react'
import Notification from '../Utils/Notification'
import { SUCCESS } from '../../utils/constants'
import { withAuth } from '../AuthContext'
import { withRouter, useLocation } from 'react-router-dom'
import Error from '../Utils/Error'
import { shouldTranslateTo } from '../../utils/utils'
import { useStateWithCallbackLazy } from 'use-state-with-callback'
import verifyAccountStatus from '../Hooks/VerifyAccountStatus'
import styled from 'styled-components'
import Cookies from 'universal-cookie'

import {
  Title,
  Subtitle,
  CustomSelect,
  CustomSubtitle,
  ActionButtons,
  Input,
  LoadingButton,
  FormInput,
  FormSelect,
  TextArea,
  CheckboxWrapper,
  CustomCheckbox,
} from '../Utils/CustomClasses'

const ContainerBox = styled.div`
  padding: 0 0 80px;
  background-color: transparent;

  @media (max-width: 799px) {
    padding: 25px 25px 25px 25px;
  }
`

const FormContent = styled.div`
  margin-top: 50px;
  display: flex;

  button {
    width: 30vw;
    min-width: 250px;

    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
`

const ErrorWrapper = styled.div`
  margin: 20px 0 0 0;
  padding: 0;

  > div {
    padding: 0;
    > label {
      margin: 0 !important;
    }
  }
`

const OnboardingTitle = styled(Title)`
  font-family: 'Open Sans', sans-serif;
`

const OnboardingSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
`

const DashLineBox = styled.div`
  margin: 40px 10vw;
  padding: 30px 100px 40px;
  border-radius: 4px;
  border: 2px dashed #0bac5d;

  @media screen and (max-width: 799px) {
    padding: 30px 5vw 40px;
    margin: 30px 0 40px;
  }
`

const DashLineBoxBottom = styled(DashLineBox)`
  margin: 100px 10vw 0;

  @media screen and (max-width: 799px) {
    padding: 30px 5vw 40px;
    margin: 100px 0 40px;
  }
`

const CustomCheckboxWrapper = styled(CheckboxWrapper)`
  color: #fff;
  margin-top: 0;
  margin-bottom: 30px;
`

const CustomCheckboxForm = styled(CustomCheckbox)`
  border: 2px solid rgba(17, 17, 19, 0.39);
  border-radius: 50%;
  margin-left: 6px;
  height: 30px;
  width: 30px;
`

const CustomInput = styled(Input)`
  height: 50px;
`

const AccountButtonMyFreebird = styled(ActionButtons)`
  background-color: transparent;
  border: 1px solid #fff;
  color: #fff;
  border-radius: 9px;
  padding: 10px 43px;
  margin: 0;
  max-width: 340px;

  @media screen and (max-width: 799px) {
    margin: 0 auto;
    width: webkit-fill-available;
  }
`

const EditProfileOnboarding = ({ data, countriesNice, onUpdate }) => {
  const [languagesOptions, setLanguagesOptions] = useState([])
  const [defaultLanguages, setDefaultLanguages] = useState([])
  const [languages, setLanguages] = useState([])
  const [languagesError, setLanguagesError] = useState(false)
  const [introduction, setIntroduction] = useState('')
  const [introductionError, setIntroductionError] = useState(false)
  const [interest, setInterest] = useState('')
  const [interestError, setInterestError] = useState(false)
  const [philosophy, setPhilosophy] = useState('')
  const [philosophyError, setPhilosophyError] = useState(false)
  const [favoBook, setFavoBook] = useState('')
  const [favoFilm, setFavoFilm] = useState('')
  const [favoActor, setFavoActor] = useState('')
  const [favoMusician, setFavoMusician] = useState('')
  const [favoPlace, setFavoPlace] = useState('')
  const [favoFood, setFavoFood] = useState('')
  const [favoExercise, setFavoExercise] = useState('')
  const [favoHero, setFavoHero] = useState('')
  const [favoVisitedPlace, setFavoVisitedPlace] = useState('')
  const [bucketListCountries, setBucketListCountries] = useState(false)
  const [defaultBucketListCountries, setDefaultBucketListCountries] =
    useState(false)
  const [bucketListCountriesError, setBucketListCountriesError] =
    useState(false)
  const [loading, setLoading] = useState('')
  const [error, setError] = useState('')
  const [pageText, setPageText] = useState([])
  const [pageText2, setPageText2] = useState([])
  const [country, setCountry] = useState({})
  const [countrySelected, setCountrySelected] = useState({})

  const [citySelect, setCitySelect] = useState('')
  const [cityInput, setCityInput] = useState('')
  const [isNewCity, setIsNewCity] = useState(false)
  const [cities, setCities] = useStateWithCallbackLazy([])
  const [countryError, setCountryError] = useState(false)
  const [cityError, setCityError] = useState(false)

  const [st, setSt] = useState('')
  const location = useLocation()
  const queryParameters = new URLSearchParams(location.search)
  const cookies = new Cookies()

  useEffect(() => {
    axios
      .get('/api/languages-all')
      .then((res) => {
        const languagesOptionsData = res.data.map(function (language) {
          return { label: language.name, value: language.id }
        })
        setLanguagesOptions(languagesOptionsData)
      })
      .catch((e) => {
        console.log(e)
      })

    setSt(queryParameters.get('st'))
    cookies.set('stss', 'y', { path: '/' })

    const user = data.auth.user
    const userLanguages = user.languages

    if (user.countryId) {
      setCountrySelected(countriesNice.find((c) => c.value === user.countryId))
      setCountry(user.countryId)
      getCities(user)
      if (user.isNewCity) {
        setIsNewCity(user.isNewCity)
        setCityInput(user.city)
      }
    }

    setLanguages(
      userLanguages &&
        userLanguages.map(function (language) {
          return language.id
        })
    )
    setDefaultLanguages(
      userLanguages &&
        userLanguages.map(function (language) {
          return { label: language.name, value: language.id }
        })
    )

    setBucketListCountries(
      data.auth.user.bucketListCountries &&
        data.auth.user.bucketListCountries.map(function (bucketCountry) {
          return bucketCountry
        })
    )

    setDefaultBucketListCountries(
      data.auth.user.bucketListCountries &&
        countriesNice &&
        data.auth.user.bucketListCountries.map(function (bucketCountry) {
          console.log('a')
          return countriesNice.find((c) => c.value === bucketCountry)
        })
    )

    setIntroduction(user.introduction)
    setInterest(user.interest)
    setFavoBook(user.favoBook)
    setFavoFilm(user.favoFilm)
    setFavoActor(user.favoActor)
    setFavoMusician(user.favoMusician)
    setFavoPlace(user.favoPlace)
    setFavoFood(user.favoFood)
    setFavoExercise(user.favoExercise)
    setFavoHero(user.favoHero)
    setFavoVisitedPlace(user.favoVisitedPlace)
    setPhilosophy(user.philosophy)

    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue, setPageState) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageState(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getPageText('profile-information', language, setPageText)
    getPageText('signup-app', language, setPageText2)
  }, [])

  const handleInputChange = (e) => {
    const target = e.target
    const name = target.name
    setError('')
    setIntroductionError(false)
    setInterestError(false)
    setLanguagesError(false)
    switch (name) {
      case 'introduction':
        setIntroduction(e.target.value)
        break
      case 'interest':
        setInterest(e.target.value)
        break
      case 'philosophy':
        setPhilosophy(e.target.value)
        break
      case 'favoBook':
        setFavoBook(e.target.value)
        break
      case 'favoFilm':
        setFavoFilm(e.target.value)
        break
      case 'favoActor':
        setFavoActor(e.target.value)
        break
      case 'favoMusician':
        setFavoMusician(e.target.value)
        break
      case 'favoPlace':
        setFavoPlace(e.target.value)
        break
      case 'favoFood':
        setFavoFood(e.target.value)
        break
      case 'favoExercise':
        setFavoExercise(e.target.value)
        break
      case 'favoHero':
        setFavoHero(e.target.value)
        break
      case 'favoVisitedPlace':
        setFavoVisitedPlace(e.target.value)
        break
      default:
        break
    }
  }

  const handleLanguageChange = (option) => {
    setError('')
    setIntroductionError(false)
    setLanguagesError(false)
    const languagesData = option.map(function (option) {
      return option.value
    })
    setLanguages(languagesData)
    setDefaultLanguages(languagesData)
  }

  const handleCountriesChange = (option) => {
    setError('')
    const countriesData = option.map(function (option) {
      return option.value
    })
    setBucketListCountries(countriesData)
    setDefaultBucketListCountries(countriesData)
  }

  const updateCountry = async ({ value }) => {
    setCitySelect('')
    setCityInput('')
    setCountryError(false)
    setError(null)
    setCountry(value)
    setCountrySelected(countriesNice.find((c) => c.value === value))
    let citiesResult = await returnCitiesList(value)
    setCities(citiesResult)
  }

  const getCities = async (user) => {
    let citiesResult = await returnCitiesList(user.countryId)
    setCities(citiesResult)
    if (user.locationId) {
      const selectedCity = citiesResult.find(
        (city) => city.value === user.locationId
      )
      setCityInput(selectedCity.label)
      setCitySelect(selectedCity.value)
    }
  }

  const returnCitiesList = async (value) => {
    try {
      const response = await axios.get(`/api/cities/${value}`)
      let citiesList = response.data.map((city) => {
        return { label: city.city, value: city.id }
      })
      return citiesList
    } catch (e) {
      console.log('Error getting cities: ', e)
    }
  }

  const { search } = data

  const updateCity = (e) => {
    setCityError(false)
    setError(null)
    if (isNewCity) {
      setCityInput(e)
    } else {
      setCityInput(e.label)
      setCitySelect(e.value)
    }
  }

  const updateIsNewCity = (e) => {
    setError(null)
    setCityInput('')
    setCitySelect(0)
    if (isNewCity) {
      setIsNewCity(false)
    } else {
      setIsNewCity(true)
    }
  }

  const handleManageAccount = (e) => {
    e.preventDefault()
    window.open('/myfreebird?s=ac', '_self')
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setBucketListCountriesError(false)

    if (!introduction) {
      setIntroductionError(true)
      setError('Please complete the introduce yourself field before proceeding')
      return
    } else if (!interest) {
      setInterstError(true)
      setError('Please complete the interests field before proceeding')
      return
    } else if (!philosophy) {
      setPhilosophyError(true)
      setError('Please add your philosophy of life before proceeding')
      return
    } else if (languages.length < 1) {
      setLanguagesError(true)
      setError('Please state which languages you can speak before proceeding')
      return
    } else if (!bucketListCountries) {
      if (!defaultBucketListCountries) {
        setBucketListCountriesError(true)
        setError('Please tell us your must visit countries before proceeding.')
        return
      } else {
        setBucketListCountries(defaultBucketListCountries)
      }
    }

    // Validate country
    if (!country) {
      setCountryError(true)
      setError(pageText2[47])
      return
    }

    // Validate city
    if (isNewCity) {
      if (!cityInput) {
        setCityError(true)
        setError(pageText2[48])
        return
      }
    } else {
      if (!citySelect) {
        setCityError(true)
        setError(pageText2[49])
        return
      }
    }

    setLoading(true)

    const userData = {
      introduction: introduction,
      interest: interest,
      philosophy: philosophy,
      favoBook: favoBook,
      favoFilm: favoFilm,
      favoActor: favoActor,
      favoMusician: favoMusician,
      favoPlace: favoPlace,
      favoFood: favoFood,
      favoExercise: favoExercise,
      favoHero: favoHero,
      favoVisitedPlace: favoVisitedPlace,
      introductionStatus: 'completed',
      interestStatus: 'completed',
      favoStatus: 'completed',
      languages: languages,
      bucketListCountries: bucketListCountries,
      countryId: country,
      locationId: isNewCity ? null : citySelect,
      city: cityInput,
      isNewCity: isNewCity,
    }

    data.auth
      .updateUser(userData)
      .then(() => {
        Notification({
          type: SUCCESS,
          message: 'Profile edited successfully',
        })

        verifyAccountStatus(data, 'editprofile')

        setTimeout(function () {
          onUpdate()
        }, 1000)

        setLoading(false)
      })
      .catch((e) => {
        Notification({
          data: e,
        })
        setLoading(false)
      })
  }

  if (pageText.length === 0 || languagesOptions.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }

  const favs = [
    {
      name: 'favoBook',
      label: pageText[23],
      placeholder: pageText[34],
      value: favoBook,
    },
    {
      name: 'favoFilm',
      label: pageText[24],
      placeholder: pageText[35],
      value: favoFilm,
    },
    {
      name: 'favoActor',
      label: pageText[25],
      placeholder: pageText[36],
      value: favoActor,
    },
    {
      name: 'favoMusician',
      label: pageText[26],
      placeholder: pageText[37],
      value: favoMusician,
    },
    {
      name: 'favoFood',
      label: pageText[28],
      placeholder: pageText[39],
      value: favoFood,
    },
    {
      name: 'favoExercise',
      label: pageText[29],
      placeholder: pageText[40],
      value: favoExercise,
    },
    {
      name: 'favoHero',
      label: pageText[30],
      placeholder: pageText[41],
      value: favoHero,
    },
  ]

  const travelFavs = [
    {
      name: 'favoPlace',
      label: pageText[27],
      placeholder: pageText[38],
      value: favoPlace,
    },
    {
      name: 'favoVisitedPlace',
      label: pageText[31],
      placeholder: pageText[42],
      value: favoVisitedPlace,
    },
  ]

  const favourites = favs.map((f) => (
    <FavInput
      key={f.name}
      name={f.name}
      label={f.label}
      value={f.value}
      onChange={(e) => handleInputChange(e)}
      placeholder={f.placeholder}
    />
  ))

  const travelFavourites = travelFavs.map((f) => (
    <FavInput
      key={f.name}
      name={f.name}
      label={f.label}
      value={f.value}
      onChange={(e) => handleInputChange(e)}
      placeholder={f.placeholder}
    />
  ))

  return (
    <ContainerBox>
      <OnboardingTitle
        center
        color="#ff9900"
        size="34px"
        sizemd="34px"
        sizesm="34px"
        margin="10px 0 0"
        dangerouslySetInnerHTML={{
          __html: `${pageText[1]}`,
        }}
      ></OnboardingTitle>

      <OnboardingSubtitle
        color="#fff"
        center
        size="20px"
        sizesm="20px"
        weight="700"
        margin="10px 0 30px"
        dangerouslySetInnerHTML={{
          __html: `The richer your profile the more interaction you will see in the community.`,
        }}
      ></OnboardingSubtitle>

      <DashLineBox>
        <form
          method="POST"
          action="/"
          name="myForm"
          aria-label="Add Profile"
          onSubmit={(e) => handleSubmit(e)}
        >
          <input
            type="hidden"
            name="csrf-token"
            value={window.Laravel.csrfToken}
          />
          {data.auth.user.status === 'partiallycompleted' && (
            <CustomSubtitle
              color="#fff"
              size="18px"
              margin="0 0 46px 0px"
              weight="400"
              dangerouslySetInnerHTML={{
                __html: `${pageText[44]}`,
              }}
            />
          )}

          {/* Philosophy of Life */}
          <CustomSubtitle
            color="#fff"
            bold
            size="22px"
            margin="25px 0 11px 0px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[13]}`,
            }}
          />
          <CustomSubtitle
            color="#fff"
            size="18px"
            margin="0 0 16px 0px"
            weight="400"
            dangerouslySetInnerHTML={{
              __html: `${pageText[14]}`,
            }}
          />
          <TextArea
            id="philosophy"
            name="philosophy"
            rows="5"
            required
            placeholder={pageText[43]}
            value={philosophy}
            className={!philosophy && 'empty-box'}
            onChange={(e) => handleInputChange(e)}
          />

          {/* INTRODUCE YORSELF */}
          <CustomSubtitle
            color="#fff"
            bold
            size="22px"
            margin="40px 0 11px 0px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[2]}`,
            }}
          />
          <CustomSubtitle
            color="#fff"
            size="18px"
            margin="0 0 16px 0px"
            weight="400"
            dangerouslySetInnerHTML={{
              __html: `${pageText[3]}`,
            }}
          />
          <TextArea
            id="introduction"
            name="introduction"
            className={introductionError && 'error-border'}
            rows="5"
            required
            placeholder={pageText[32]}
            value={introduction}
            onChange={(e) => handleInputChange(e)}
          />
          {/* Interests */}
          <CustomSubtitle
            color="#fff"
            bold
            size="22px"
            margin="40px 0 11px 0px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[4]}`,
            }}
          />
          <CustomSubtitle
            color="#fff"
            size="18px"
            margin="0 0 16px 0px"
            weight="400"
            dangerouslySetInnerHTML={{
              __html: `${pageText[5]}`,
            }}
          />
          <TextArea
            id="interest"
            name="interest"
            rows="5"
            placeholder={pageText[33]}
            required
            value={interest}
            onChange={(e) => handleInputChange(e)}
          />

          {/* MY TRAVELS */}
          <CustomSubtitle
            color="#fff"
            bold
            size="22px"
            margin="40px 0 11px 0px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[52]}`,
            }}
          />
          <CustomSubtitle
            color="#fff"
            size="18px"
            margin="0 0 30px 0px"
            weight="400"
            dangerouslySetInnerHTML={{
              __html: `${pageText[53]}`,
            }}
          />

          <CustomSubtitle
            color="#fff"
            size="18px"
            margin="0 0 16px 0px"
            weight="400"
            dangerouslySetInnerHTML={{
              __html: `What countries are on your ‘must visit’ list?`,
            }}
          />

          <FormSelect
            width="100%"
            id="bucketListCountries"
            name="bucketListCountries"
            height="auto"
            margin="0 0 30px 0"
            className={bucketListCountriesError && 'error-border'}
            isDisabled={false}
            isLoading={false}
            isClearable={false}
            isRtl={false}
            isSearchable={true}
            options={countriesNice}
            required
            onChange={handleCountriesChange}
            isMulti
            defaultValue={defaultBucketListCountries}
          />

          {travelFavourites}

          {/* FAVORITE THINGS */}
          <CustomSubtitle
            color="#fff"
            bold
            size="22px"
            margin="30px 0 11px 0px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[11]}`,
            }}
          />
          <CustomSubtitle
            color="#fff"
            size="18px"
            margin="0 0 30px 0px"
            weight="400"
            dangerouslySetInnerHTML={{
              __html: `${pageText[12]}`,
            }}
          />
          {favourites}

          {/* Location */}
          <CustomSubtitle
            color="#fff"
            bold
            size="22px"
            margin="30px 0 11px 0px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[50]}`,
            }}
          />
          <CustomSubtitle
            color="#fff"
            size="18px"
            margin="0 0 16px 0px"
            weight="400"
            dangerouslySetInnerHTML={{
              __html: `${pageText[51]}`,
            }}
          />

          {/* Country */}
          <CustomSubtitle
            color="#fff"
            bold
            size="18px"
            margin="0 0 6px 0px"
            dangerouslySetInnerHTML={{
              __html: pageText2[16],
            }}
          />
          <CustomSelect
            width="-webkit-fill-available"
            placeholder={pageText2[17]}
            defaultValue={{
              value: countrySelected,
              label: country !== undefined ? country : pageText2[32],
            }}
            value={countrySelected}
            className={countryError && 'error-border'}
            isDisabled={true}
            isLoading={false}
            isClearable={true}
            isRtl={false}
            isSearchable={true}
            name="country"
            options={countriesNice}
            onChange={(e) => updateCountry(e)}
          />
          {/* Town */}
          {!isNewCity ? (
            <div>
              <CustomSubtitle
                color="#fff"
                bold
                size="18px"
                margin="0 0 6px 0px"
                dangerouslySetInnerHTML={{
                  __html: pageText2[18],
                }}
              />
              <CustomSelect
                width="-webkit-fill-available"
                margin="0 0 10px"
                placeholder={pageText2[19]}
                defaultValue={'Select..'}
                className={cityError && 'error-border'}
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                name="town"
                options={cities}
                value={
                  cityInput === ''
                    ? pageText2[32]
                    : {
                        label: cityInput,
                        value: citySelect,
                      }
                }
                onChange={(e) => updateCity(e)}
              />
            </div>
          ) : (
            <div>
              <CustomSubtitle
                color="#fff"
                bold
                size="18px"
                margin="0 0 6px 0px"
                dangerouslySetInnerHTML={{
                  __html: pageText2[33],
                }}
              />
              <CustomInput
                id="city"
                type="text"
                name="town"
                margin="0 0 10px"
                className={cityError && 'error-border'}
                placeholder={pageText2[34]}
                value={cityInput}
                onChange={(e) => updateCity(e.target.value)}
              />
            </div>
          )}
          <CustomCheckboxWrapper onClick={(e) => updateIsNewCity(e.target)}>
            <CustomCheckboxForm onClick={(e) => updateIsNewCity(e.target)}>
              {isNewCity && <img src="/images/check-icon.svg" />}
            </CustomCheckboxForm>
            {pageText2[20]}
          </CustomCheckboxWrapper>

          {/* LANGUAGES */}
          <CustomSubtitle
            color="#fff"
            bold
            size="22px"
            margin="40px 0 11px 0px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[15]}`,
            }}
          />
          <CustomSubtitle
            color="#fff"
            bold
            size="18px"
            margin="0 0 11px 0px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[16]}`,
            }}
          />

          <FormSelect
            width="100%"
            id="languages"
            name="languages"
            className={languagesError && 'error-border'}
            isDisabled={false}
            isLoading={false}
            isClearable={false}
            isRtl={false}
            isSearchable={true}
            options={languagesOptions}
            required
            onChange={handleLanguageChange}
            isMulti
            defaultValue={defaultLanguages}
          />

          <FormContent>
            {loading ? (
              <LoadingButton padding="9px 10px">{pageText[17]}</LoadingButton>
            ) : (
              <ActionButtons type="submit" padding="9px 10px">
                {pageText[17]}
              </ActionButtons>
            )}
          </FormContent>

          <ErrorWrapper>{error && <Error error={error} />} </ErrorWrapper>
        </form>
      </DashLineBox>

      <DashLineBoxBottom>
        <CustomSubtitle
          color="#fff"
          bold
          size="18px"
          margin="0 0 30px 0px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[54]}`,
          }}
        />
        <AccountButtonMyFreebird
          color="#transparent"
          type="submit"
          padding="10px 60px"
          margin=" 0"
          fontsizesm="16px"
          onClick={(e) => handleManageAccount(e)}
        >
          {pageText[55]}
        </AccountButtonMyFreebird>
      </DashLineBoxBottom>
    </ContainerBox>
  )
}

const FavInput = (props) => {
  return (
    <div>
      <CustomSubtitle
        color="#fff"
        mediumBold
        size="18px"
        sizesm="16px"
        margin="0 0 11px 0px"
        dangerouslySetInnerHTML={{
          __html: `${props.label}`,
        }}
      />
      <FormInput
        id={props.name}
        type="text"
        row="2"
        name={props.name}
        placeholder={props.placeholder}
        onChange={props.onChange}
        defaultValue={props.value}
        //className={!props.value && 'empty-box'}
        autoComplete="off"
      />
    </div>
  )
}

export default withRouter(withAuth(EditProfileOnboarding))
